import { create } from 'zustand';
import { createCompanySlice } from './slices/createCompanySlice';
import { createMarketerSlice } from './slices/createMarketerSlice';
import { createReceiptsSlice } from './slices/createReceiptsSlice';
import { createFileSlice } from './slices/createFileSlice';
import { createPostsSlice } from './slices/createPostsSlice';
import { createCrmCallsSlice } from './sub-slices/reports/CrmCallsSlice';

export const useNonePersistedStore = create()(
    (set, get) => ({
        ...createCompanySlice(set),
        ...createMarketerSlice(set, get),
        ...createReceiptsSlice(set, get),
        ...createFileSlice(set, get),
        ...createPostsSlice(set, get),
    }),
)